module.exports = __webpack_public_path__ + "static/media/Athens.b7ab514c.jpg";